import Vue from 'vue'
import user from '@/api/modules/user'
import { checkAdvisoryRole } from '@/utils/roles'

const getDefaultState = () => {
  return {
    isAdmin: false,
    profile: null
  }
}

const state = getDefaultState()

const actions = {
  fetchUser (context, cached = true) {
    if (cached && state.user) {
      return Promise.resolve()
    } else {
      return user.fetch()
        .then((data) => {
          context.commit('saveUserData', data)
          return Promise.resolve()
        })
        .catch(({response}) => {
          if (response.status === 401) {
            context.commit('resetState')
            return Promise.reject(response.status)
          }
        })
    }
  }
}

const mutations = {
  saveUserData (state, data) {
    Vue.set(state, 'profile', data)

    const adminStatus = data.roles.find(role => role === 'admin')
    state.isAdmin = Boolean(adminStatus)
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  userName ({ profile }) {
    if (profile) {
      const {
        firstName,
        lastName,
        email
      } = profile

      return firstName ? `${firstName} ${lastName}` : email
    }

    return ''
  },

  isAdvisor ({ profile }) {
    return profile
      ? checkAdvisoryRole(profile.roles)
      : false
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
